import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { getCelebratedPersonName } from '../helpers';
import { videoIsProcessed } from '../../../../../../../util/video';
import GreetingVideo from './GreetingVideo';
import Logo from '../../../../../../../components/global/Logo';
import Button from '../../../../../../../components/global/Button';

const propTypes = {
  headerless: PropTypes.bool.isRequired,
  album: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  greetingVideo: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  onAddPhotosClick: PropTypes.func.isRequired,
};

const MemoryBookContent = ({
  headerless,
  album,
  greetingVideo,
  onAddPhotosClick,
}) => {
  const celebratedName = getCelebratedPersonName(
    album.album_subtype,
    album.root_album_folder.event_settings,
    false,
    album?.root_album_folder?.account?.organization_name ??
      album?.root_album_folder?.account?.name,
  );
  const posessiveCelebratedName = getCelebratedPersonName(
    album.album_subtype,
    album.root_album_folder.event_settings,
    true,
    album?.root_album_folder?.account?.organization_name ??
      album?.root_album_folder?.account?.name,
  );

  return (
    <Fragment>
      {!headerless && (
        <Fragment>
          <div className="mb-3">
            <Logo />
          </div>
          <h5 className="mb-1 text-center text-uppercase text-light">
            Welcome to
          </h5>
          <h2 className="mb-3 text-black text-center">
            {posessiveCelebratedName} Memories Slideshow
          </h2>
        </Fragment>
      )}
      <p className="h4 text-normal">
        Help make{' '}
        <span className="text-extra-bold">{posessiveCelebratedName}</span>{' '}
        Memories Slideshow amazing!
      </p>
      {videoIsProcessed(greetingVideo) && (
        <Fragment>
          <p className="h4 text-normal">
            Watch video message from{' '}
            <span className="text-extra-bold text-primary">
              {album.creator.name}
            </span>
            :
          </p>
          <GreetingVideo greetingVideo={greetingVideo} className="mb-3" />
        </Fragment>
      )}
      <Button
        btnOutline
        onClick={onAddPhotosClick}
        className="h4 text-normal d-inline-block"
      >
        Please upload any old photos you have of <br />
        <span className="text-extra-bold text-primary">{celebratedName}</span>
      </Button>
    </Fragment>
  );
};

MemoryBookContent.propTypes = propTypes;

export default MemoryBookContent;
